"use client"

import * as SwitchPrimitive from "@radix-ui/react-switch"
import type * as React from "react"

import { cn } from "@/lib"

function Switch({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default"
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "peer data-[state=checked]:bg-black data-[state=unchecked]:border-black focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-[#F2F0EB40] dark:data-[state=checked]:bg-[#5A5B3F] dark:data-[state=unchecked]:border-[#615f5b40] group/switch inline-flex shrink-0 cursor-pointer items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[1.7rem] data-[size=default]:w-12 data-[size=sm]:h-4 data-[size=sm]:w-6",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-white data-[state=unchecked]:bg-black dark:bg-[#F2F0EB] dark:data-[state=checked]:bg-[#F2F0EB] pointer-events-none block rounded-full ring-0 transition-transform group-data-[size=default]/switch:size-6 group-data-[size=sm]/switch:size-3 data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-[1px]",
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
